import { useContext } from 'react';
import UserContext from '@lib/contexts/userContext';
import { useQuery } from '@tanstack/react-query';
import { API_URLS, axiosRequest } from '@lib/axios';
import useStaffUserLookup from "@components/common/hooks/useStaffUserLookup";

const useEventListQuery = (params) => {
  const { authenticated } = useContext(UserContext);
  const {
    isStaffLoading,
    isStaffRefetching,
    isStaffError,
    staffError,
    setMetadataNames
  } = useStaffUserLookup();

  // The filters are stored in an array, not an object, to allow the same field name to appear multiple times
  // in the query string, e.g., created_by=alice@example.com&created_by=bob@example.com
  const filters = Object.keys(params?.filters).reduce((acc, key) => {
    const value = params?.filters[key];
    // console.log('filter value', key, value);
    if (!value) {
      return acc;
    }
    const valuesArray = Array.isArray(value) ? value : [value];

    switch (key) {
      case 'program_areas':
        valuesArray.forEach(v => acc.push([`${key}:array_contains`, v]));
        break;
      case 'main_office':
      case 'created_by':
        valuesArray.forEach(v => acc.push([`${key}`, v.id || v]));
        break;
      default: break;
    }
    return acc;
  }, []);

  const query = new URLSearchParams(filters);

  const {
    data,
    isLoading,
    isRefetching,
    error,
    isError,
  } = useQuery({
    queryKey: ['events', query.toString()],
    queryFn: () => axiosRequest({ method: 'GET', url: `${API_URLS.EVENTS}?${query.toString()}`}),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
    select: (events) => {
      if (!events) {
        return [];
      }
      events.forEach((e) => {
        e.curriculum_name = e?.curriculum?.name || 'Booth';
        setMetadataNames(e);
      });
      return events;
    }
  });

  return {
    data,
    isLoading: (isLoading) || (isStaffLoading),
    // refetch,
    isRefetching: (isRefetching) || (isStaffRefetching),
    error: error || staffError,
    isError: isError || isStaffError,
  }
};

export default useEventListQuery;
